import React, { Component } from "react";

const UnPinIcon = ({ width, height, fill }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 29 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1476_58)">
        <path
          d="M17.1424 15.5153L17.5294 18.3526L16.7271 19.1549L12.7211 15.1489L8.8212 19.0489L7.9387 18.9686L7.85846 18.0861L11.7584 14.1862L7.75241 10.1802L8.55469 9.37792L11.2974 9.67027L17.0712 3.89647L16.0677 2.89294L16.87 2.09066L24.722 9.94274L23.9198 10.745L22.9162 9.74147L17.1424 15.5153ZM9.85682 10.6801L16.1326 16.9559L15.886 14.8463L21.9535 8.77876L18.0339 4.85921L11.9664 10.9267L9.85682 10.6801Z"
          fill={fill}
        />
        <rect
          x="11.708"
          y="3.29199"
          width="16.0738"
          height="2.5"
          transform="rotate(45 11.708 3.29199)"
          fill={fill}
        />
        <rect
          x="11.9219"
          y="3.01562"
          width="16.118"
          height="1.34665"
          transform="rotate(45 11.9219 3.01562)"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1476_58">
          <rect width="28.8" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

UnPinIcon.defaultProps = {
  width: 29,
  height: 24,
  fill: "black",
};

export default UnPinIcon;
